import { render, staticRenderFns } from "./appRegisterList.vue?vue&type=template&id=8264efdc&scoped=true&"
import script from "./appRegisterList.vue?vue&type=script&lang=js&"
export * from "./appRegisterList.vue?vue&type=script&lang=js&"
import style0 from "./appRegisterList.vue?vue&type=style&index=0&id=8264efdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8264efdc",
  null
  
)

export default component.exports